import { Button } from 'components/buttons'
import { Icon } from 'components/icon'
import { Typography } from 'components/typography'
import { Icons, ModalExportSuccesProps, TypographyTypes } from 'interfaces'
import React from 'react'
import { TailwindModal } from '../tailwindModal'

const ExportDataSuccesModal: React.FC<ModalExportSuccesProps> = ({
	open,
	setOpen,
	setMyPeopleDataSelected,
	setSelectAllUsers,
	isReach,
	errorMessage
}) => {
	const handleConfirmClick = (): void => {
		if (isReach) {
			setOpen(!open)
		} else {
			setOpen(!open)
			setMyPeopleDataSelected?.([])
			setSelectAllUsers?.(false)
		}
	}

	const isError = Boolean(errorMessage)
	const iconSrc = isError ? Icons.warning : Icons.checkCircle
	const iconClass = isError ? 'text-red-500' : 'text-blue-primary'
	const title = isError
		? `Export failed: ${errorMessage}. Please try again or contact support if the problem persists.`
		: 'Your export request was successful! We will send the CSV file containing the data of your selected users to your email.'

	return (
		<TailwindModal
			open={open}
			setOpen={setOpen}
			showCloseButton
			className="w-[22.380rem] p-4 rounded-[16px] flex flex-col"
		>
			<div className="flex flex-col gap-4 w-full">
				<div className="flex flex-col gap-3 w-full items-center">
					<div className="w-[30px] h-[30px]">
						<Icon src={iconSrc} fillPath className={iconClass} />
					</div>

					<Typography
						title={title}
						fontLeading="15/18"
						type={TypographyTypes.h3}
						className="!font-normal text-black-1 text-center"
					/>
				</div>
				<div className="flex justify-center items-center gap-4 w-full">
					<Button
						label="OK"
						className="!min-w-[unset] !py-3 !px-9"
						onClick={() => handleConfirmClick()}
					/>
				</div>
			</div>
		</TailwindModal>
	)
}

export default ExportDataSuccesModal
